// Core
import { Link, Route, Switch, Redirect, useRouteMatch, useLocation, useHistory, useParams } from 'react-router-dom';
import { useState, useCallback, useRef, useEffect } from 'react';
import { useQuery } from 'react-query';
import { FaPlus } from 'react-icons/fa6';
import { BsArrowUpCircleFill } from 'react-icons/bs';
import { IoIosClose } from 'react-icons/io';
import { 
  Box, 
  Button,
  SimpleGrid,
  FormControl,
  Input,
  InputGroup,
  InputLeftElement,
  Flex, 
  Text,
  Select,
  Stack,
  Radio,
  Menu, 
  Image,
  Tooltip,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  IconButton,
  MenuButton, 
  MenuList, 
  MenuItem,
  Textarea,
  useDisclosure,
  useColorModeValue
} from '@chakra-ui/react';
import { BsSendFill } from 'react-icons/bs';
import { FaArrowLeft, FaTelegramPlane } from 'react-icons/fa';
import { FaCircleInfo } from 'react-icons/fa6';
import { MdDelete } from 'react-icons/md';

// Assets
import { apiService } from 'services/ApiService';
import { parseMessageDate } from 'services/Utils';
import placeholderUser from 'assets/img/placeholder-user.png';
import { textLang } from 'services/Lang';

// Components
import MatchInfo from '../MatchPeople/components/MatchInfo';

function Items(props) {
  const textColor = useColorModeValue('#0E1633', 'white');
  const bgColorMe = useColorModeValue('#fff5f5', '#0E1633');
  const bgColorUser = useColorModeValue('white', '#0D234D');

  const { id } = useParams();
  const debounceRef = useRef(null);
  const [showInfo, setShowInfo] = useState(0);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isOpenInfo, onOpen: onOpenInfo, onClose: onCloseInfo } = useDisclosure();
  const { isOpen: isOpenUn, onOpen: onOpenUn, onClose: onCloseUn } = useDisclosure();
  const [offset, setOffset] = useState(0); 
  const [objects, setObjects] = useState([]);
  const [newObjectErrors, setNewObjectErrors] = useState([]);
  const [newObject, setNewObject] = useState({});
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const limit = 50;
  const [objectsMeta, setObjectMeta] = useState({total: 0, limit, offset}); 

  const { refetch, isFetching, isLoading } = useQuery({
    queryKey: ['objects', offset],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const params = {
        limit,
        offset,
        id,
      };

      const response = await apiService.getMessages(params);
      setObjects(response.data);
      setObjectMeta(response.meta);
      return true;
    },
    refetchInterval: 5000,
  });

  const { data: matchInfo, isFetching: matchInfoIsFetching } = useQuery({
    queryKey: ['matchInfo'],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const response = await apiService.getMatchInfo({id});
      return response.data;
    },
    retry: false
  });

  const chatRef = useRef(null);

  const [message, setMessage] = useState();
  const [isValidInputMessage, setIsValidInputMessage] = useState(true);  
  const handleSendMsg = (event) => {
    const value = event.target.value;
    setMessage(value);
    setIsValidInputMessage(true);  
  };

  const sendMsg = async () => {
    if(message?.length < 1){ 
      setIsValidInputMessage(false);
      return;
    }

    try {
      const body = {
        id: +id,
        text: message
      };

      const response = await apiService.createMessage(body);
      if(response.data === false || response.statusCode !== 200){
        setIsValidInputMessage(false);
        return;
      }
    } catch(e){
      setIsValidInputMessage(false);
      return;
    }

    setTimeout(() => { refetch(); }, 500);
    setMessage('');
    setIsValidInputMessage(true);

    if (!chatRef.current) { return; }

    const el = chatRef.current;
    el.scrollTop = el.scrollHeight;
  };

  useEffect(() => {
    if (!chatRef.current) { return; }

    const el = chatRef.current;
    const scrollThreshold = 50;

    const isAtBottom = el.scrollHeight - el.scrollTop - el.clientHeight < scrollThreshold;

    if (isAtBottom) {
      setTimeout(() => {
        el.scrollTop = el.scrollHeight;
      }, 100);
    }
  }, [objects, isLoading]);

  useEffect(() => {
    if(matchInfo?.userMatched?.username === null || matchInfo?.user?.username === null){
      onOpen();  
    }
  }, [matchInfo]);

  const history = useHistory();
  const [isLoadingDeleteMatch, setIsLoadingDeleteMatch] = useState(false);
  const deleteMatch = useCallback(async () => {
    setIsLoadingDeleteMatch(true);
    try {
      await apiService.deleteMatch({id: matchInfo?.id});
    } catch (e){}

    setTimeout(() => {
      setIsLoadingDeleteMatch(false);
      onCloseUn();
      history.push('/messages'); 
    }, 3500);
    return true;
  });

  return (
    <Box p="100px 15px 0px 15px" position="relative">
        <Box align='left' mt='18px'>
    <Box 
      position="absolute"
      transform="translate(-50%, -60px)"
      left="50%"
      zIndex="9"
      > 
      <Button 
        variant="solid-sm" 
        w="120px"
        onClick={onOpenUn} 
        leftIcon={<MdDelete fontSize="21px" />}>{textLang('Delete')}</Button>
    </Box>

  	<Box zIndex="9" position="relative">
      <Flex justifyContent="space-between" overflow="visible" borderRadius="30px 30px 0 0" p="8px" alignItems="center" position="relative">
        <Box w="100%" borderRadius="30px 30px 0 0" h="100%" left="0px" position="absolute" bottom="0" bg="white" zIndex="0" />
        <Box w="100%" h="30px" left="0px" position="absolute" bottom="-28px" bg="linear-gradient(180deg, #ffffff, transparent)" zIndex="1" />
    		<Link to="/messages">
    			<Button variant="button-md" w="100px" leftIcon={<FaArrowLeft />}>{textLang('back')}</Button>
    		</Link>

        <Flex gap="0px" alignItems="center" zIndex="99">
          <IconButton
              icon={<FaCircleInfo fontSize="24px" color="rgb(255, 65, 51) !important" />}
              variant="ghost-sx"
              size="md"
              w="8px"
              onClick={onOpenInfo}
              color="rgb(255, 65, 51)!important"
              aria-label=""
            />

          <Text variant="title-lg" fontSize="24px" zIndex="9">{objectsMeta?.total}</Text>
        </Flex>

        <Flex alignItems="center" gap="6px" zIndex="1">
          <Text
            whiteSpace='nowrap'
            overflow='hidden'
            textOverflow='ellipsis'
            maxWidth='100px' 
            variant="title-lg">{props?.object?.id === matchInfo?.owner ? matchInfo?.userMatched?.firstName : matchInfo?.user?.firstName}</Text>
          <Box borderRadius="full" w="44px" h="44px" >
            <Image 
              onClick={() => setShowInfo(true)}
              src={props?.object?.id === matchInfo?.owner ? 
                      matchInfo?.userMatched?.image 
                      : matchInfo?.user?.image
                    || placeholderUser} 
              w="100%" h="100%"
              objectFit="cover" 
              />
          </Box>
        </Flex>
      </Flex>

      <Box ref={chatRef} h="calc(100vh - 300px)" overflow="auto" pt="20px">
  	    {!isLoading && [...objects].sort((a, b) => a.id - b.id).map((item, index) => (
	        <>
	          <Flex
              position="relative"
              key={index}
              justifyContent={ item?.owner === props?.object?.id ? 'end' : 'start' }
              gap="8px"
              mb="8px">

              { item?.owner !== props?.object?.id && (
                <Box w="40px">
                  <Image src={
                    props?.object?.id === matchInfo?.owner ? 
                      matchInfo?.userMatched?.image 
                      : matchInfo?.user?.image
                    || placeholderUser
                    } w="40px" h="40px" objectFit="cover" borderRadius="full" />
                </Box>
              )}

              <Flex
                borderRadius={ item?.owner !== props?.object?.id ? '12px 12px 12px 0px' : '12px 12px 0px 12px' }
                p="10px 12px 12px 12px"
                position="relative"
                gap="12px"
                maxW="80%"
                alignItems="end"
                bg={ item?.owner !== props?.object?.id ? bgColorUser : bgColorMe }>
                <Text color={textColor} wordBreak="break-all" style={{ whiteSpace: 'pre-wrap' }}>{item?.text}</Text>
                <Text 
                  overflow="visible !important"
                  whiteSpace="nowrap"
                  variant="text-xs" 
                  color="#9FABCB">
                  {parseMessageDate(item?.createdAt)}
                </Text>
              </Flex>

            </Flex>
	        </>
        ))}

        { !isLoading && objects?.length === 0 &&
          <Text
          	textAling="center"
          	variant="title-lg" 
          	position="fixed"
          	transform="translate(-50%, 0px)"
  			    left="50%"
          	top="40%"
            textAlign="center"
          	>{textLang('messages_empty')}</Text>
        }
       
      </Box> 

      <Modal isOpen={isOpenInfo} onClose={onCloseInfo}>
        <ModalOverlay />
        <ModalContent className="modal__simple" 
            maxW={{ base: '330px' }} 
            style={{ border:'1px solid #2ABDFD', overflow: 'hidden' }}>
                          
            <Box position="relative" p="24px" bg='white !important' textAlign="center">
                <Text>
                {textLang('messages_limit')}</Text>
      
                <Flex mt="18px" gap="12px">
                  <Button variant="button-md" onClick={onCloseInfo}>{textLang('messages_limit_btn')}</Button>
                </Flex>
            </Box>

        </ModalContent>
      </Modal> 

      <Modal isOpen={isOpenUn} onClose={onCloseUn}>
        <ModalOverlay />
        <ModalContent className="modal__simple" 
            maxW={{ base: '330px' }} 
            style={{ border:'1px solid #2ABDFD', overflow: 'hidden' }}>
                          
            <Box position="relative" p="24px" bg='white !important' textAlign="center">
                <Text variant="title-lg">{textLang('messages_delete_header')}</Text>
                <Text mt="8px">
                  {textLang('messages_delete_text')}
                </Text>
      
                <Button 
                  mt="18px" 
                  variant="solid-md" 
                  isLoading={isLoadingDeleteMatch}
                  onClick={deleteMatch}>{textLang('Delete')}</Button>

                <Button 
                  mt="8px" 
                  variant="button-md" 
                  onClick={onCloseUn}>{textLang('cancel')}</Button>
            </Box>

        </ModalContent>
      </Modal> 

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent className="modal__simple" 
            maxW={{ base: '330px' }} 
            style={{ border:'1px solid #2ABDFD', overflow: 'hidden' }}>
                          
            <Box position="relative" p="24px" bg='white !important' textAlign="center">
                <Text>{textLang('messages_end_text')}</Text>
      
                <Flex mt="18px" gap="12px">
                  <Button variant="button-md" onClick={onClose}>{textLang('messages_limit_btn')}</Button>
                </Flex>
            </Box>

        </ModalContent>
      </Modal> 

      { objectsMeta?.total >= 20 ? 
        <Box bg="#ffffff" position="fixed" left="0" bottom="0px" w="100%" h="124px" left="0" p="15px">
          <Button as="a" href={`https://t.me/${
            props?.object?.id === matchInfo?.owner ? matchInfo?.userMatched?.username : matchInfo?.user?.username
            }`} variant="button-md" leftIcon={<FaTelegramPlane fontSize="21px" />}>{textLang('messages_btn_to_tg')}</Button>
        </Box>
      :
  	    <Box bg="#ffffff" position="fixed" left="0" bottom="0px" w="100%" h="124px" left="0" p="8px">
  	    	<Flex gap="0px" alignItems="center" p="0 6px" h="100%">
  		    	<Textarea
              value={message}
              onChange={handleSendMsg}
              className={isValidInputMessage ? 'input-valid' : 'input-invalid'}
              placeholder={textLang('messages_placeholder')}
              autoComplete="off" 
              h="100% !important" 
              w="100%" 
              padding="6px 12px !important"
              bg="linear-gradient(180deg, #f1f1f1, transparent) !important" 
              borderRadius="16px !important"></Textarea>
  		    	<Box w="70px">
  		    		<BsArrowUpCircleFill onClick={sendMsg} fontSize="36px" color="rgb(255, 65, 51)" style={{margin: '0 auto'}} />
  		    	</Box>
  	    	</Flex>
  	    </Box> 
      }

      <Box className="match-user-info" h={ showInfo ? '80%' : '0' }>
          <Box onClick={() => setShowInfo(false)} top="20px" right="10px" position="absolute">
            <IoIosClose fontSize="70px" />
          </Box>
          <MatchInfo item={props?.object?.id === matchInfo?.owner ? matchInfo?.userMatched : matchInfo?.user} />
      </Box>
  	</Box>
    </Box>
    </Box>
  );
}

export default Items;